<div style="display: flex;justify-content: space-between;">
  <app-breadcrumb></app-breadcrumb>
  <button class="download-btn"  (click)="downloadAsPDF()"
        [disabled]="downloadButtonText !== 'Download as PDF'">
        <i class="fas fa-download"></i>
    </button>
</div>

<div class="release-notes-container" style="margin-top: 20px;">
    <!--<div class="row">
       <h2 class="release-notes-title">Release Notes</h2>
    <button class="download-btn"  (click)="downloadAsPDF()"
        [disabled]="downloadButtonText !== 'Download as PDF'">
        <i class="fas fa-download"></i>
    </button>
    </div>-->
    <div [innerHTML]="releaseNotes" class="markdown-content" id="releaseNotesContent"></div>
</div>